const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS'

export const reducer = (state = [], action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return [...state, action.notification]
    case RESET_NOTIFICATIONS:
      return []
    default:
      return state
  }
}

export const notify = notification => ({
  type: ADD_NOTIFICATION,
  notification,
})

export const resetNotifications = () => ({
  type: RESET_NOTIFICATIONS,
})

const DEFAULT_ERROR_TITLE = 'Oh no! Something went awry!'

export const createErrorOptions = (error, override) => {
  const message =
    error.message ||
    error.statusText ||
    (error.body && (error.body.title || error.body.message)) ||
    error.toString()

  return {
    title: DEFAULT_ERROR_TITLE,
    color: 'error',
    message: `Error: ${message}`,
    ...override,
  }
}

export const createInfoOptions = (message, override) => ({
  title: message,
  color: 'info',
  ...override,
})

export const createSuccessOptions = (message, override) => ({
  title: message,
  color: 'success',
  ...override,
})
export const createWarningOptions = (message, override) => ({
  title: message,
  color: 'caution',
  ...override,
})
